export function scrollAnime() {
  const scrollAnime = document.querySelectorAll('.js-scrollAnime');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('is-visible')) {

        entry.target.classList.add('is-visible');

        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    threshold: 0.5,
  });

  scrollAnime.forEach(target => observer.observe(target));
}